import { createCustomEnum } from "../customEnum";

export type CommissionsFeeTypesTypes = "multiply" | "flat_rate";

const CommissionsFeeTypes = createCustomEnum({
	Multiply: {
		value: 0,
		name: "multiply",
		displayName: "Multiply",
	},
	FlatRate: {
		value: 1,
		name: "flat_rate",
		displayName: "Flat Rate",
	},
});

export default CommissionsFeeTypes;
